import { all } from 'redux-saga/effects'
import AppSagas from "./app/saga.jsx";

export default function* rootSaga() {
  yield all([AppSagas()])
};
